import { useEffect, useState } from 'react'

import { extractMFA } from '@/lib/helpers'
import { parseHorIdFromHtml } from '@/pages/shortlist/helpers'
import type { RoutesType } from '@/routes/routes'
import { ROUTES } from '@/routes/routes'
import { isUserLogged } from '@/storage/helpers'

import { useOffice } from './useOffice'
import { useUserExpiry } from './useUser'

const getAddinRoute = (emailBody: string): RoutesType => {
  const { isMFAEmail, token } = extractMFA(emailBody)
  if (isMFAEmail && token) {
    return ROUTES.MFA
  }
  const isLogged = isUserLogged()
  if (!isLogged) {
    return ROUTES.LOGIN
  }

  const isShortlist = parseHorIdFromHtml(emailBody).wasFound
  if (isShortlist) {
    return ROUTES.SHORTLIST
  }

  return ROUTES.HOUSING_REQUEST
}

export const useDecideRoute = () => {
  const [intendedRoute, setIntendedRoute] = useState<RoutesType | null>(null)
  const { isUserExpired } = useUserExpiry()

  useEffect(() => {
    if (![ROUTES.MFA, ROUTES.LOGIN].includes(intendedRoute) && isUserExpired) {
      setIntendedRoute(ROUTES.LOGIN)
    }
  }, [isUserExpired])

  const onUpdateRoute = (emailBody: string) => {
    const route = getAddinRoute(emailBody)
    setIntendedRoute(route)
  }

  useOffice({
    onItemBodyChangedCallback: onUpdateRoute,
  })

  const forceRoute = (route: RoutesType) => {
    setIntendedRoute(route)
  }

  const forceUpdateRoute = () => {
    const msg = Office.context.mailbox.item
    if (!msg?.body) {
      return
    }
    msg.body.getAsync('html', (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        onUpdateRoute(result.value)
      }
    })
  }

  return {
    isReady: intendedRoute !== null,
    intendedRoute,
    forceRoute,
    forceUpdateRoute,
  }
}
